import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import DatePicker from 'vue2-datepicker';
import assetViewDetails from '../../assetAudit/assetViewDetails';
import Highcharts from 'highcharts';
import circularProgression from './circularProgression/circularProgression'
export default {
  name: 'scannedAssets',
  components: {
    appStrings,
    DatePicker,
    commonHelper,
    assetViewDetails,
    circularProgression
  },
  props: ['rowData','faLoc','currentLocation'],
  watch: {
    currentPage: function() {
      this.getScannedAssetDetails()
      //   this.getassetMasterItems();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getScannedAssetDetails()
      //   this.getassetMasterItems();
    }
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      responseMsg: '',
      isSuccess: false,
      showAlert: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      scannedAssetsData: [],
      scannedAssetsFields: [
        {
          key: 'bar_code',
          label: 'Scanned QR Code',
          class:'alignItem'
        },
        // {
        //   key: 'doc_num',
        //   label:'Asset Number'
        // },
        // {
        //   key:'serial_no',
        //   label:'Serial Number'
        // },
        // {
        //   key:'asset_type',
        //   label: 'Asset Type'
        // },
        // {
        //   key: 'asset_item'
        // },
        // {
        //   key:'asset_name',
        //   label:'Item Description'
        // },
        // {
        //   key:'view_details'
        // }
      ],
      assetNum: null,
      showAssetDetailsModalFlag:false,
      accessButtons:{},
      scannedCount:0,
      totalCount:0,
      chartData1 : [],
      scannedCounts: 72,
      totalCounts: 100
    };
  },
  computed: {
    scannedPercent() {
      if(this.totalCount){
        return Math.round((this.scannedCount/ this.totalCount) * 100);
      }
      else{
        return 0
      }
    },
    remainingAssets() {
      const remaining = this.totalCount - this.scannedCount;
      return remaining < 0 ? 0 : remaining;
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          //   this.showHideAddFaLocationModal(true);
        //   this.postBarcodes();
        } 
      }
    });
    this.getScannedAssetDetails();
    this.getTotalAssetsCount();
    
  },
  methods: {
    getScannedAssetDetails() {
      const payload = {
        auditHdrId: this.rowData.audit_hdr_id,
      };
      this.loader = true;
      this.$store
        .dispatch('assets/getScannedAssetDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.scannedAssetsData = resp.data.data;
            // this.totalRows = resp.data.data.total_elements;
            this.scannedCount=this.scannedAssetsData.length
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showAssetDetailsModal(flag,asstDetail){
      this.showAssetDetailsModalFlag=flag;
      if (flag) {
        this.assetNum=asstDetail;
        this.accessButtons = {
          deleteAllow: false,
          downloadAllow: false,
          uploadAllow: false,
          editAllow: false,
          addAllow: false,
          printAllow: false,
          approvalAllow: false
        };
    }
    },
    getTotalAssetsCount() {
      const payload = {
       auditHdrId:this.rowData.audit_hdr_id,
       faLocId: this.faLoc
      };
      this.loader = true;
      this.$store
        .dispatch('assets/getAuditAssetCount', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const respData =resp.data.data
            respData.map(ele=>{
              this.totalCount+=ele.count
            })
            this.chartData1 = respData.map(item => [item.item_name, item.count]);
            // this.totalCount=resp.data.data
            if(this.chartData1){
              this.showCharts();
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showCharts(){
      Highcharts.chart('chart-container3', {
        chart: {
          type: 'pie',
          height: 300,
          borderRadius:18,
          backgroundColor: '#ffffff', 
        },  
        title: {
          text: this.currentLocation.text,
          style:{
            color: 'black',
            fontWeight:'bold'
          }
        },
        plotOptions: {
          pie: {
             allowPointSelect: true,
              cursor: 'pointer',          
            dataLabels: {
              enabled: true,
              color:'black',
              format:  '<b>{point.name}</b><br>{point.percentage:.1f}%',
              style: {
                fontFamily: 'Open Sans',
                fontWeight:'x-small',
                textOutline:'none'
              },
              distance:30,
            }
          }
        },
          tooltip:{
         style: {
                fontFamily: 'Open Sans',
              }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        series: [
          {
            name: 'Data',
            size: '70%',
            data: this.chartData1,
            innerSize: '30%',
          }
        ]
      });
    },
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
